import { cn } from '@/lib/utils';
import React, { useEffect, useMemo, useState } from 'react';
import { AssetsFaultIndicator } from '../AssetsFaultIndicator';
import { useQueryNavigation, useViewportWidth } from '@/hooks/shared';
import { ExceedingComponentsPopover } from './ExceedingComponentsPopover';
import { FILTER_PARAMS } from '@/types/shared/navigation-tabs.enums';
import { useNavigate } from 'react-router-dom';

interface FaultyComponentsProps {
  faulty_components: any[];
  asset_id: string;
  maxBadges?: number;
  className?: string;
}

export const FaultyComponents = ({ faulty_components, asset_id, maxBadges, className }: FaultyComponentsProps) => {
  const faulty_componentsTMP = faulty_components;
  const { isMobile, isTablet } = useViewportWidth();
  const navigate = useNavigate();
  const { navigateWithQuery } = useQueryNavigation();

  const [maxItems, setMaxItem] = useState(maxBadges || 2);
  useEffect(() => {
    setMaxItem(maxBadges || isMobile ? 1 : 2);
  }, [isMobile, isTablet, maxBadges]);

  const shownItems = useMemo(() => faulty_componentsTMP?.slice(0, maxBadges), [faulty_components, maxBadges]);
  const exceededItems = useMemo(() => faulty_componentsTMP?.slice(maxBadges), [faulty_components, maxBadges]);

  return (
    <div className={cn(`flex gap-1 `)}>
      {shownItems?.map((el, index) => {
        const faultType = el.unit_ui_name ? `${el.unit_ui_name} - ${el.component_ui_name}` : el.component_ui_name;

        return (
          el.component_ui_name && (
            <AssetsFaultIndicator
              onClick={(e: any) => {
                e.stopPropagation();
                // const params = new URLSearchParams();
                // params.append(FILTER_PARAMS.SELECTED_COMPONENT, el.component_id);
                navigateWithQuery(`${asset_id}/components`, {
                  addParams: { [FILTER_PARAMS.SELECTED_COMPONENT]: el.component_id },
                });
              }}
              key={index}
              healthStatus={el.health_status}
              faultType={faultType}
              className={className}
            />
          )
        );
      })}
      {exceededItems.length > 0 && <ExceedingComponentsPopover items={exceededItems} asset_id={asset_id} />}
    </div>
  );
};
